import { Navigate, Outlet } from "react-router-dom";
import { getAuthToken } from "../features/auth/utils/authSession";

const ProtectedRoute = () => {
    const token = getAuthToken();

    if (!token) {
        return <Navigate to="/login" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;
